import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { A, fillPlaceholders } from '../../routing';
import styles from './desktop-nav.module.scss';

interface SubmenuItem {
  label: string;
  href?: string;
  params?: Record<string, any>;
  onClick?: () => void;
}

interface NavSubmenuProps {
  items: SubmenuItem[];
  isOpen: boolean;
  onItemClick?: () => void;
}

export const NavSubmenu: React.FC<NavSubmenuProps> = ({ items, isOpen, onItemClick }) => {
  const location = useLocation();

  const isItemActive = (href: string, params?: Record<string, any>): boolean => {
    const fullPath = params ? fillPlaceholders(href, params) : href;
    return location.pathname === fullPath;
  };

  return (
    <div className={styles.submenu} data-open={isOpen}>
      {items.map((item, index) => {
        // If item has onClick handler (gated feature), it's not a link
        if (item.onClick) {
          return (
            <div
              key={index}
              className={styles.submenuItem}
              onClick={() => {
                item.onClick?.();
                onItemClick?.();
              }}
              role="button"
              tabIndex={0}
            >
              <FormattedMessage id={`nav.${item.label.toLowerCase().replace(/\s+/g, '_')}`} defaultMessage={item.label} />
            </div>
          );
        }

        // Regular navigation item
        const isActive = isItemActive(item.href!, item.params);
        return (
          <div key={index} onClick={onItemClick}>
            <A href={item.href!} hrefParams={item.params || {}} className={styles.submenuItem} data-active={isActive}>
              <FormattedMessage id={`nav.${item.label.toLowerCase().replace(/\s+/g, '_')}`} defaultMessage={item.label} />
            </A>
          </div>
        );
      })}
    </div>
  );
};
